function CheckboxCellRenderer(params) {

  return params.value;
}

export default CheckboxCellRenderer;
